import styled from "styled-components";

const PopupContainer = styled.span`
  display: block;
  background: #ffffff;
  border: 1px solid ${({ theme }) => (theme.darkMode ? "#5D5D5D" : "#dcdcdc")};
  box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  padding: 16px 24px;

  .scripture-styles & {
    display: block;
    background: ${({ theme }) =>
      theme.darkMode ? theme.computedPrimary : "white"};
    border: 1px solid ${({ theme }) => (theme.darkMode ? "#5D5D5D" : "#dcdcdc")};
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 16px 24px;
  }
`;

export default PopupContainer;
